import { initComponent } from './core/init-component';

initComponent('.js-hero', (section) => {
  const cover = section.querySelector('.js-hero-cover') as HTMLElement;
  const coverHitbox = section.querySelector('.js-hero-cover-hitbox') as HTMLElement;

  // Drawer open/close + portal now live in the generic `drawer.ts` (`.js-drawer`).
  // The hero only keeps the cover's cursor-follow parallax.
  if (coverHitbox && cover) {
    const animateMe = (e: MouseEvent) => {
      const rect = cover.getBoundingClientRect();

      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const width = rect.width;
      const height = rect.height;

      const move = 20;
      const xMove = (x / width) * (move * 2) - move;
      const yMove = (y / height) * (move * 2) - move;

      cover.style.transform = `translate(${xMove}px, ${yMove}px)`;
    };

    coverHitbox.addEventListener('mousemove', animateMe);

    coverHitbox.addEventListener('mouseleave', () => {
      cover.style.transform = '';
    });
  }
});
